/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import {useState} from 'react';
import {handleApiError} from 'helpers';
import {skipStepInKycFlow} from 'api';

const useSkipStep = () => {
  const [isLoading, setIsLoading] = useState(false);

  const skipStep = async (onSuccess) => {
    try {
      setIsLoading(true);
      const res = await skipStepInKycFlow();
      if (res.status === 200) {
        if (onSuccess) {
          onSuccess();
        }
      }
      return res;
    } catch (error) {
      handleApiError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    skipStep,
    isLoading,
  };
};

export default useSkipStep;
